import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipDevicesViewProps } from "./Params"

// Devices grouped by category (electric / nautical / safety). Detail-level section;
// each non-empty category becomes its own container.
export function PrintShipDevicesView({ data }: PrintShipDevicesViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  if (includeShipDataType !== ShipDataType.details) {
    return null;
  }

  return (
    <>{["electric", "nautical", "safety"].map((type) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
      const devices = shipData?.devices?.[type as keyof typeof shipData.devices] as any[] | undefined;
      if (!devices || devices.length === 0) return null;

      return (
        <PrintListBlock key={type} title={t(`${type}_equipment`)}>
          {devices.map((device, index) => (
            <div key={device.id || index}>
              <BlockRow className="block-row-followed-by-block-row">
                <BlockField label={t("device")} className="block-field-150">{device.deviceType ? (predefined.deviceTypes[type]?.includes(device.deviceType) ? t(`device_${type}_${device.deviceType}`) : device.deviceType) : device.deviceType}</BlockField>
                <BlockField label={t("manufacturer")} className="block-field-210">{device.manufacturer}</BlockField>
                <BlockField label={t("model")} className="block-field-150">{device.model}</BlockField>
                <BlockField label={t("serial_number")} className="block-field-120">{device.serialNumber}</BlockField>
                <BlockField label={t("date_installation")} className="block-field-120">{device.dateInstallation}</BlockField>

              </BlockRow>

              <BlockRow className="block-row-last">
                <BlockField label={t("place_installation")} className="block-field-150">{device.placeInstallation}</BlockField>
                <BlockField label={t("comment")}>{device.specialFeatures}</BlockField>
              </BlockRow>

            </div>
          ))}
        </PrintListBlock>
      );
    })}</>
  );
}
